import { SET_AVATARS } from "../types/avatarsTypes";

const initialState = {
  avatars: [],
};

const avatarsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_AVATARS:
      return { ...state, avatars: action.payload };
    default:
      return state;
  }
};

export default avatarsReducer;
